import React, { useEffect, useState } from "react";
// import { PeopleAltOutlined, Payment, Apartment } from '@material-ui/icons';
// import { useHistory } from 'react-router-dom';
import { baseUrl } from "../../../../services/config";
import { useAlert } from "react-alert";
// import AddchartIcon from '@mui/icons-material/Addchart';
import { Paper } from "@material-ui/core";
import {
  Table,
  Modal,
  Spinner,
  Alert,
  Form,
  ModalFooter,
  Badge,
} from "react-bootstrap";
// import makeAnimated from 'react-select/animated';
// import { components } from 'react-select';
// import MySelect from './../../CustomChallan/MySelect';
// import DatePicker from 'react-multi-date-picker';
// import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import "./DateSheetStyle.css";
import { date } from "yup";
import { useSelector } from "react-redux";

const ExamList = ({
  show,
  onHide,
  selectedclassfordatesheet,
  examid,
  showdetailmodal,
}) => {
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const [session, setSession] = useState([]);
  const [datesheetlist, setdatesheetlist] = useState([]);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [allexamslist, setallexamslist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedyear, setselectedyear] = useState("");
  const [selectedExamType, setselectedExamType] = useState("");
  const alert = useAlert();

  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  //functions

  useEffect(() => {
    getAllYear();
  }, []);

  const getAllYear = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Data", data);
        setSession([...data.payload]);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setselectedyear(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDateSheetHandler = () => {
    if (
      campusId == "" ||
      selectedExamType == "" ||
      classId == "" ||
      courseId == ""
    ) {
      return alert.error("Please select all fields");
    }
    setLoading(true);
    let data = {
      campus_id: campusId,
      course_id: courseId,
      exam_id: selectedExamType,
      student_class_id: classId,
      // education_type:educationType,
    };

    fetch(`${baseUrl}/exam_class_datesheet`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        console.log("Data", data);
        setdatesheetlist(data.payload);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onCampusChange = async (id) => {
    setCampusId(id);
    setselectedExamType("");
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getAllExamsList(id);
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }

    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getAllExamsList = (id) => {
    const data = {
      year_id: selectedyear,
      campus_id: campusId,
      course_id: id,
    };

    fetch(`${baseUrl}/exam_for_session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("get exam", data);

        setallexamslist([...data.payload]);
        // getassignedExamsList(data.payload)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <div className="row">
            {/* Select Year */}

            <div className="col-md-3">
              <label>
                <b>Select Session</b> <span style={{ color: "red" }}>*</span>
              </label>
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={selectedyear}
                onChange={(e) => {
                  setselectedyear(e.target.value);
                  //   getDateSheetHandler(e.target.value, selectedexam);
                }}
                aria-label="Default select example"
              >
                <option value=""> Select Session</option>
                {session.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.year}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>
                <b>Select Campus</b> <span style={{ color: "red" }}>*</span>
              </label>
              <select
                style={{ height: 40 }}
                className="form-select"
                name="campus_id"
                value={campusId}
                onChange={(e) => onCampusChange(e.target.value)}
                aria-label="Default select example"
              >
                <option value=""> Select Campus</option>
                {campuses.map((campus, index) => (
                  <option key={index} value={campus.id}>
                    {campus.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>
                <b>Select Course </b> <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className="form-select"
                name="course_id"
                value={courseId}
                onChange={(e) => onCourseChange(e.target.value)}
                style={{ backgroundColor: "white", height: 40 }}
                aria-label="Default select example"
              >
                <option value="">Select Course</option>
                {campusCourseData.map((item, index) => (
                  <option key={index} value={item.course?.id}>
                    {item.course?.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Select Exam */}
            <div className="col-md-3">
              <label>
                <b>Select Exam</b> <span style={{ color: "red" }}>*</span>
              </label>
              <select
                onChange={(e) => {
                  setselectedExamType(e.target.value);
                }}
                value={selectedExamType}
                class="form-select"
                style={{ height: 40 }}
                // value={currentsession}
                aria-label="Default select example"
              >
                <option value="">Select Exam</option>
                {allexamslist.map((exam) => (
                  <option
                    // selected={exam.active_academic_year == "1" ? true : false}
                    value={exam.id}
                  >
                    {exam?.exam_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3 mt-5">
              <label>
                <b>Select Class</b> <span style={{ color: "red" }}>*</span>
              </label>

              <select
                style={{ height: 40 }}
                className="form-select"
                name="class_id"
                value={classId}
                onChange={(e) => setClassId(e.target.value)}
                aria-label="Default select example"
              >
                <option value=""> Select Class</option>
                {courseClassData.map((item, index) => (
                  <option key={index} value={item.class?.id}>
                    {item.class?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3 mt-14">
              <button className="btn btn-primary" onClick={getDateSheetHandler}>
                Show
              </button>
            </div>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner class="text-center" variant="info" animation="border" />
            </div>
          ) : null}
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th>ID</th>
                <th>Date</th>
                <th>Subject</th>
                <th>Class Name</th>
                {/* <th>Note</th> */}
              </tr>
            </thead>

            <tbody>
              {datesheetlist.subjects?.map((item, index) => (
                <tr id="tbl">
                  <td style={{ color: "black" }} className="text_align_start">
                    {item.id}
                  </td>
                  <td style={{ color: "black" }} className="text_align_start">
                    {item.date}
                  </td>
                  <td style={{ color: "black" }} className="text_align_start">
                    {item.subject.name}
                  </td>
                  <td style={{ color: "black" }} className="text_align_start">
                    {datesheetlist.student_class.name}
                  </td>
                  {/* <td style={{ color: 'black' }} className='text_align_start'></td> */}
                  {/* <td style={{ color: 'black' }} className='text_align_start'></td>
                  <td style={{ color: 'black' }} className='text_align_start'></td>
                  <td style={{ color: 'black' }} className='text_align_start'></td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Paper>
    </div>
  );
};

export default ExamList;
